import * as Request from '../request'
import * as Router from '../router/constants'
import * as Constants from './constants'
import * as Types from './types'

export const initialState: Types.State = {
  initialized: false,
  selectedCommunity: '',
  urlParams: {},
  viewport: {
    isLarge: false,
    isMedium: false,
    isSmall: false,
  },
}
type Action =
  Types.SelectCommunityAction &
  Types.MediaQueryAction &
  Request.SuccessAction &
  {params: {}} &
  {urlParams: {}}
export const reducer = (state: Types.State = initialState, action: Action) => {
  switch (action.type) {
    case Constants.CONTENT_INIT:
      return {
        ...state,
        initialized: true,
      }
    case Router.ON_ENTER:
      return {
        ...state,
        urlParams: action.urlParams,
      }
    case Constants.URL_PARSED:
      return {
        ...state,
        urlParams: action.params,
      }
    case Constants.MEDIA_QUERY_SET:
      return {
        ...state,
        viewport: {
          // 992+
          isLarge: action.window.matchMedia(`(min-width: ${Constants.BREAKPOINTS.Medium}px)`).matches,
          // 768 - 991.98
          isMedium: action.window.matchMedia(
            `(min-width: ${Constants.BREAKPOINTS.Small}px) and (min-width: ${Constants.BREAKPOINTS.Medium - 0.02}px)
          `).matches,
          // 0 - 767.98
          isSmall: action.window.matchMedia(`(max-width: ${Constants.BREAKPOINTS.Small - 0.02}px)`).matches,
        },
      }
    case Constants.SELECT_COMMUNITY:
      return {
        ...state,
        selectedCommunity: action.communityIdentifier,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/reducer.ts